import { useEffect, useRef } from 'react';

import { usePlayerStore } from '../components/PlayerContextProvider';

export const REVERSE_PLAYBACK_INTERVAL = 100;

export const usePlayerReversePlayback = () => {
  const videoElement = usePlayerStore((state) => state.videoElement);
  const playbackRate = usePlayerStore((state) => state.playbackRate);
  const previousPlayed = useRef(false);

  useEffect(() => {
    if (playbackRate && playbackRate <= 0 && videoElement) {
      /**
       * We need to pause the video before we start rewinding it to avoid the video from
       * flickering at lower playback speeds.
       */
      if (!videoElement.paused) {
        videoElement.pause();

        previousPlayed.current = true;
      } else {
        previousPlayed.current = false;
      }

      const reversePlaybackInterval = setInterval(() => {
        if (!videoElement.paused) {
          videoElement.pause();
        }

        if (videoElement.currentTime > 0) {
          const newCurrentTime = videoElement.currentTime + (REVERSE_PLAYBACK_INTERVAL / 1000) * playbackRate;
          if (newCurrentTime < 0) {
            videoElement.currentTime = 0;
          } else {
            videoElement.currentTime = newCurrentTime;
          }
        } else {
          clearInterval(reversePlaybackInterval);
        }
      }, REVERSE_PLAYBACK_INTERVAL);

      return () => {
        clearInterval(reversePlaybackInterval);

        if (previousPlayed.current) {
          videoElement.play();
        }
      };
    }
  }, [playbackRate, videoElement]);
};
